import dayjs from "dayjs";


// // import { apiCall } from "./index";

// // // Overtime API endpoints
// // export const getOvertimeRequests = (params = {}) => {
// //   const queryParams = new URLSearchParams(params).toString();
// //   return apiCall(`/overtime/request?${queryParams}`);
// // };

// // export const getOvertimeRequestById = (requestId) =>
// //   apiCall(`/overtime/request/${requestId}`);

// // export const createOvertimeRequest = (requestData) =>
// //   apiCall(`/overtime/request`, "POST", requestData);

// // export const updateOvertimeRequest = (requestId, requestData) =>
// //   apiCall(`/overtime/request/${requestId}`, "PUT", requestData);

// // export const deleteOvertimeRequest = (requestId) =>
// //   apiCall(`/overtime/request/${requestId}`, "DELETE");

// // export const approveOvertimeRequest = (requestId) =>
// //   apiCall(`/overtime/request/${requestId}/approve`, "PATCH");

// // export const rejectOvertimeRequest = (requestId, reason = "") =>
// //   apiCall(`/overtime/request/${requestId}/reject`, "PATCH", { reason });

// // export const getOvertimeSummary = (userId, params = {}) => {
// //   const queryParams = new URLSearchParams(params).toString();
// //   return apiCall(`/overtime/summary/${userId}?${queryParams}`);
// // };

// // export const getPendingOvertimeRequests = (params = {}) => {
// //   const queryParams = new URLSearchParams(params).toString();
// //   return apiCall(`/overtime/pending?${queryParams}`);
// // };

// // api/attendance.js
// import { apiCall } from "./index";

// // Overtime API endpoints
// export const getMyOvertimeRequests = (params = {}) => {
//   const queryParams = new URLSearchParams(params).toString();
//   return apiCall(`/overtime/my-requests?${queryParams}`);
// };

// export const getOvertimeRequests = () =>
//   apiCall(`/overtime/request`);

// export const createOvertimeRequest = (requestData) =>
//   apiCall(`/overtime/request`, "POST", requestData);

// export const updateOvertimeRequest = (requestId, requestData) =>
//   apiCall(`/overtime/request/${requestId}`, "PUT", requestData);

// export const deleteOvertimeRequest = (requestId) =>
//   apiCall(`/overtime/request/${requestId}`, "DELETE");

// export const approveOvertimeRequest = (requestId) =>
//   apiCall(`/overtime/${requestId}/approve`, "POST");

// export const rejectOvertimeRequest = (requestId, reason = "") =>
//   apiCall(`/overtime/${requestId}/reject`, "POST", { reason });

// export const cancelOvertimeRequest = (requestId, cancelReason = "") =>
//   apiCall(`/overtime/${requestId}/cancel`, "POST", { cancel_reason: cancelReason });





// api/attendance.js
import { apiCall } from "./index";
import { API_URL } from "../config";

// Overtime API endpoints
export const getMyOvertimeRequests = (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  return apiCall(`/overtime/my-requests?${queryParams}`);
};

export const getOvertimeRequests = (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  return apiCall(`/overtime/request?${queryParams}`);
};


// export const getAttendenceStatus = (params = {}) => {
//   const queryParams = new URLSearchParams(params).toString();
//   return apiCall(`/attendance/status?${queryParams}`);
// };



// export const getAttendenceStatus = (params = {}) => {
//   const queryParams = new URLSearchParams(params).toString();
//   return apiCall(`/attendance/status?${queryParams}`);
// };


// export const getUserAttendanceSummary = async (userId, params = {}) => {
//     const queryParams = new URLSearchParams(params).toString();
//   return apiCall(`/attendance/status?UserId=${userId}${queryParams}`);
// };



export const getAttendenceStatus = (params = {}) => {
  const today = dayjs().format("YYYY-MM-DD");

  const safeParams = { ...params };

  // ⛔ Block future "to" date
  if (safeParams.to && dayjs(safeParams.to).isAfter(today)) {
    safeParams.to = today;
  }

  // ⛔ If "from" itself is future → no API call
  if (safeParams.from && dayjs(safeParams.from).isAfter(today)) {
    return Promise.resolve({ timeline: [] });
  }

  const queryParams = new URLSearchParams(safeParams).toString();
  return apiCall(`/attendance/status?${queryParams}`);
};

export const getUserAttendanceSummary = async (userId, params = {}) => {
  const today = dayjs().format("YYYY-MM-DD");

  const safeParams = { ...params };

  if (safeParams.to && dayjs(safeParams.to).isAfter(today)) {
    safeParams.to = today;
  }

  if (safeParams.from && dayjs(safeParams.from).isAfter(today)) {
    return { timeline: [] };
  }

  const queryParams = new URLSearchParams(safeParams).toString();
  return apiCall(`/attendance/status?UserId=${userId}&${queryParams}`);
};


export const getOvertimeHistory = (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  return apiCall(`/overtime/all-overtimes-history?${queryParams}`);
};

export const attendenceTeam = (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  return apiCall(`/team-attendance-summary?${queryParams}`);
};


export const attendenceMonthlySummary = (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  return apiCall(`/attendance/monthly-summary?${queryParams}`);
};

export const getAttendanceGapReasons = (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  return apiCall(`/attendance-gap-reason?${queryParams}`);
};

export const exportAttendanceGapReasons = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const token = localStorage.getItem("authToken");

  const response = await fetch(`${API_URL}/attendance-gap-reason/export?${queryParams}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error(`Export failed: ${response.status} ${response.statusText}`);
  }

  return response.blob();
};

export const cutAttendanceGapSalary = (gapReasonId, payload = {}) =>
  apiCall(`/attendance-gap-reason/${gapReasonId}/cut-salary`, "POST", payload);



export const createOvertimeRequest = (requestData) =>
  apiCall(`/overtime/request`, "POST", requestData);

export const updateOvertimeRequest = (requestId, requestData) =>
  apiCall(`/overtime/request/${requestId}`, "PUT", requestData);

export const deleteOvertimeRequest = (requestId) =>
  apiCall(`/overtime/request/${requestId}`, "DELETE");

export const approveOvertimeRequest = (requestId, status_reason = "") =>
  apiCall(`/overtime/${requestId}/approve`, "POST", { status_reason });

export const rejectOvertimeRequest = (requestId, status_reason = "") =>
  apiCall(`/overtime/${requestId}/reject`, "POST", { status_reason });

export const cancelOvertimeRequest = (requestId, cancelReason = "") =>
  apiCall(`/overtime/${requestId}/cancel`, "POST", { cancel_reason: cancelReason });
